import "./App.css";
// import RenderOnAuthenticated from './services/RenderOnAuthenticated';
// import RenderOnAnonymous from './services/RenderOnAnonymous'
import RenderOnAuthenticated from './KC-Auth/RenderOnAuthenticated';
import RenderOnAnonymous from './KC-Auth/RenderOnAnonymous'
import AuthService from "./services/AuthService.js";
import Navbar from "./Components/Navbars/Navbar.jsx";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { Provider } from "react-redux";
import store from "./Redux/Store/store";
import Simulator from "./Components/Simulator/Simulator.jsx"
import Home from "./Components/Home/Home.jsx";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Optimizer from "./Components/Optimizer/Optimizer.jsx";
import MarketAnalysis from "./Components/Market Analysis/MarketAnalysis.jsx";
import CompetitiveAnalysis from "./Components/CompetitiveAnalysis";
import ModelPerformance from "./Components/Model Performance/ModelPerformance.jsx";
import SavedReports from "./Components/Saved Reports/SavedReports.jsx";
import Support from "./Components/Profile/Support.jsx";
import EventManagement from "./Components/Event Management/EventManagement";
import Dashboard from "./Components/Home/Dashboard.jsx";
import Navbar2 from "./Components/Navbars/Navbar2.jsx";
import RefreshModel from "./Components/Refresh Model/RefreshModel.jsx";

import UserService from "./services/UserService.js";
import PageNotFound from "./Components/PageNotFound.jsx";
import MyProfile from "./Components/Profile/MyProfile.jsx";
import Updates from "./Components/Profile/Updates.jsx";


import './Assets/css/css.css';
import './Assets/css/menu.css';
import './Assets/css/flexslider.css';
import './Assets/css/responisve.css'
import './Assets/css/modulemenu.css'
import './Assets/css/afterloginmenu.css'
import './Assets/css/brandaccordion.css'
import './Assets/css/loader.css'
import './Assets/css/event.css'
import BrandAnalysis from "./Components/Brand Analysis/BrandAnalysis.jsx";
import SavedScenarios from "./Components/Saved Scenarios/SavedScenarios.jsx";
import SimulatorAtta from "./Components/Simulator Atta/SimulatorAtta.jsx";
import OptimizerAtta from "./Components/Optimizer Atta/OptimizerAtta.jsx";
import MarketAnalysisAtta from "./Components/Market Analysis/MarketAnalysisAtta.jsx";
import BrandAnalysisAtta from "./Components/Brand Analysis/BrandAnalysisAtta.jsx";
import SavedScenariosAtta from "./Components/Saved Scenarios/SavedScenarioAtta.jsx";

function App() {
  return (
    <div className="App ">
      <Provider store={store}>
        <BrowserRouter>
          <ReactNotifications />
          <RenderOnAuthenticated>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/simulator" element={<Simulator />} />
              <Route exact path="/attasimulator" element={<SimulatorAtta />} />
              <Route exact path="/optimizer" element={<Optimizer />} />
              <Route exact path="/attaoptimizer" element={<OptimizerAtta />} />
              <Route exact path="/eventmanagement" element={<EventManagement />} />
              <Route exact path="/competitiveanalysis" element={<CompetitiveAnalysis />} />
              <Route exact path="/marketanalysis" element={<MarketAnalysis />} />
              <Route exact path="/attamarketanalysis" element={<MarketAnalysisAtta />} />
              <Route exact path="/brandanalysis" element={<BrandAnalysis />} />
              <Route exact path="/attabrandanalysis" element={<BrandAnalysisAtta />} />
              <Route exact path="/dashboard" element={<Dashboard />} />
              <Route exact path="/modelperformance" element={<ModelPerformance />} />
              <Route exact path="/savedreports" element={<SavedReports />} />
              <Route exact path="/support" element={<Support />} />
              {UserService.hasRole(["adminrole"]) ? <Route exact path="/refreshmodel" element={<RefreshModel />} /> : <Route exact path="/*" element={<PageNotFound />} />}
              <Route exact path="/savedscenarios" element={<SavedScenarios />} />
              <Route exact path="/attasavedscenarios" element={<SavedScenariosAtta />} />
              <Route exact path="/profile" element={<MyProfile />} />
              <Route exact path="/updates" element={<Updates />} />
            </Routes>
          </RenderOnAuthenticated>
          <RenderOnAnonymous>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </RenderOnAnonymous>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
